import { BulkOperations } from '@openx/components-header/BulkOperations/BulkOperations.tsx';
import type { ActionButtonProps } from '@openx/components-header/HeaderActions/ActionButton.tsx';
import { type JSX, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { GetAudiencesListQuery } from '../../../../graphql/query/audiences/GetAudiencesList.generated.tsx';
import { useArchiveAudiences } from '../hooks/useArchiveAudiences.tsx';
import { useAudienceListFetch } from '../hooks/useAudienceListFetch.tsx';

type AudienceBulkOperationsProps = {
  selectedAudiences: GetAudiencesListQuery['audience'];
  closeAndUnselect: () => void;
};

export const AudienceBulkOperations = ({
  selectedAudiences,
  closeAndUnselect,
}: AudienceBulkOperationsProps): JSX.Element => {
  const { t } = useTranslation();
  const { refetch } = useAudienceListFetch();
  const { openArchiveModal, isLoading: archiveLoading } = useArchiveAudiences();

  const actions: ActionButtonProps[] = useMemo(() => {
    return [
      {
        label: t('Archive'),
        color: 'error',
        disabled: archiveLoading,
        loading: archiveLoading,
        onClick: () => {
          openArchiveModal({
            audiences: selectedAudiences,
            onSuccess: () => {
              refetch();
              closeAndUnselect();
            },
          });
        },
      },
    ];
  }, [selectedAudiences, t, archiveLoading, openArchiveModal, closeAndUnselect, refetch]);

  return <BulkOperations selectedItems={selectedAudiences} actions={actions} onClose={closeAndUnselect} />;
};
